import { apiClient } from 'src/utils/apiClient';

export interface ClubDivision {
  divisionId: number;
  divisionName: string;
  divisionAbbreviation: string;
  totalTeams: number;
}

export type ClubDivisions = ClubDivision[];

interface ClubDivisionsResponse {
  error: boolean;
  code: number;
  message: string;
  details: Array<{
    division_id: number;
    division_name: string;
    division_abbreviation: string;
    total_teams: number;
  }>;
}

export async function getClubDivisions(siteCode: string): Promise<ClubDivisions> {
  const { details } = await apiClient<ClubDivisionsResponse>('/v1/website/divisions', { siteCode });

  return details.map(division => ({
    divisionId: division.division_id,
    divisionName: division.division_name,
    divisionAbbreviation: division.division_abbreviation,
    totalTeams: division.total_teams,
  }));
}
